<template>
  <div>
    <div>
      <v-row no-gutters class="info-row">
        <v-col cols="12" class="d-flex align-center">
          <v-tooltip bottom max-width="320" content-class="pkmn-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" small color="grey">
                mdi-information-outline
              </v-icon>
            </template>
            <span>
              Multiple discount lists can be active at the same time. If a
              date appears in more than one active list, only one discount
              will be applied — make sure your active lists don't overlap on
              the same dates.
            </span>
          </v-tooltip>
          <span class="info-row__text">
            Multiple discount lists can be active at once
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="23">
          <data-table-discounts
            :data="discounts"
            :showEdit="false"
            :isLocationProduct="isLocationProduct"
            @edit="editDiscount"
            @view="viewDiscount"
            @delete="deleteDiscount"
            @close="close"
            @showLocations="showLocations"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import auth from '@/auth'
import DataTableDiscounts from '@/components/Merchant/DataTable/DataTableDiscounts'

export default {
  name: 'MerchantDiscounts',
  props: {
    discounts: {
      type: Array,
      required: true
    },
    isLocationProduct: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DataTableDiscounts
  },
  data() {
    return {
      auth: auth
    }
  },
  methods: {
    editDiscount(discount) {
      this.$emit('edit', discount)
    },
    viewDiscount(discount) {
      this.$emit('view', discount)
    },
    deleteDiscount(discount) {
      this.$emit('delete', discount)
    },
    close() {
      this.$emit('close')
    },
    showLocations(item) {
      this.$emit('showLocations', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.submit-button {
  position: absolute;
  bottom: 24px;
  width: 100%;
  max-width: 339px;
}

.info-row {
  margin-top: 16px;
  margin-bottom: -8px;
}

.info-row__text {
  margin-left: 8px;
  color: rgba(31, 31, 31, 0.6);
  font-size: 12px;
}
</style>
